import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "../i18n";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-[130px] lg:px-10">
        <h1 className="font-serif text-5xl text-[#141414]">
          Datenschutzerklärung
        </h1>

        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-gray-700">
          <section data-testid="privacy-responsible-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              1. Verantwortliche Stelle
            </h2>
            <p className="mt-3">
              Singh Taxi, INA-Ring 12, 91074 Herzogenaurach, Deutschland.
              Telefon: {PHONE_DISPLAY} · E-Mail: {EMAIL}
            </p>
          </section>

          <section data-testid="privacy-data-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              2. Erhebung und Verarbeitung personenbezogener Daten
            </h2>
            <p className="mt-3">
              Wenn Sie uns per Telefon, E-Mail oder WhatsApp kontaktieren oder
              das Buchungsformular nutzen, verarbeiten wir die von Ihnen
              übermittelten Angaben (Name, Telefonnummer, Abholort, Ziel,
              Termin und Anmerkungen) ausschließlich zur Bearbeitung Ihrer
              Anfrage und zur Durchführung der Beförderung. Die Verarbeitung
              erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
            </p>
          </section>

          <section data-testid="privacy-maps-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              3. Google Maps
            </h2>
            <p className="mt-3">
              Zu Ihrer Orientierung binden wir eine Karte von Google Maps ein.
              Beim Laden der Karte werden Daten an Google übertragen. Weitere
              Informationen finden Sie in der Datenschutzerklärung von Google.
            </p>
          </section>

          <section data-testid="privacy-rights-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              4. Ihre Rechte
            </h2>
            <p className="mt-3">
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung oder
              Löschung Ihrer gespeicherten Daten sowie das Recht, sich bei
              einer Datenschutz-Aufsichtsbehörde zu beschweren. Wenden Sie sich
              für alle Anfragen rund um den Datenschutz an {EMAIL} oder{" "}
              {PHONE_DISPLAY}.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
